//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// eslint-disable-next-line import/no-extraneous-dependencies
import { mapGetters } from 'vuex';
import featureFlagMixin from '@motionelements/core/src/components/mixins/feature-flag.mixin.js';
import experimentMixin, {
  SUBSCRIBE_PAGE_EXPERIMENT_ID,
} from '@motionelements/core/src/components/mixins/experiment-variation.mixin.js';

export default {
  name: 'SubscriptionPage',
  components: {
    UnactivatedAccountFlash: () => import('@motionelements/core/src/components/account/UnactivatedAccountFlash.vue'),
    SubscribeHero: () => import('@/components/subscribe/SubscribeHero.vue'),
    SubscribeBenefits: () => import('@/components/subscribe/SubscribeBenefits.vue'),
    FussFreeLicensing: () => import('@/components/subscribe/FussFreeLicensing.vue'),
    SubscribeCurations: () => import('@/components/subscribe/SubscribeCurations.vue'),
    SubscribeCatalog: () => import('@/components/subscribe/SubscribeCatalog.vue'),
    SubscribePaymentMethods: () => import('@/components/subscribe/SubscribePaymentMethods.vue'),
    TeamPlanBanner: () => import('@/components/subscribe/TeamPlanBanner.vue'),
    SubscribeWebinar: () => import('@/components/subscribe/SubscribeWebinar.vue'),
    SubscribeTestimonials: () => import('@/components/subscribe/SubscribeTestimonials.vue'),
    SubscribeScrollToTop: () => import('@/components/subscribe/SubscribeScrollToTop.vue'),
    HomeFaqs: () => import('@/components/home-page/HomeFaqs.vue'),
    HomeLicensing: () => import('@/components/home-page/HomeLicensing.vue'),
    BaseBreadcrumbs: () => import('@/components/core/BaseBreadcrumbs.vue'),
    PageMeta: () => import('@motionelements/core/src/components/ThePageMeta.vue'),
    //
    SubscribeHero2026: () => import('@/components/subscribe2026/SubscribeHero2026.vue'),
    SubscribeBenefits2026: () => import('@/components/subscribe2026/SubscribeBenefits2026.vue'),
    FussFreeLicensing2026: () => import('@/components/subscribe2026/FussFreeLicensing2026.vue'),
    PageLoader: () => import('@motionelements/core/src/components/ui/PageLoader.vue'),
  },
  mixins: [featureFlagMixin, experimentMixin],
  // default layout uses <Nuxt keep-alive> — use activated (not only mounted) so
  // landing → subscribe → landing → subscribe re-runs ensure/reload
  activated() {
    this.initExperiment(SUBSCRIBE_PAGE_EXPERIMENT_ID);
  },
  watch: {
    userCurrency: { // @toDo @Pavlo why we need to watch userCurrency and resend getPlans
      handler(toCurrencyCode) {
        if (toCurrencyCode) {
          this.$store.dispatch('subscription/getPlans');
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters({
      userCurrency: 'user/currencyCode',
    }),
    /**
     * Subscribe page A/B from ?x= (SSR-safe): x=1 → legacy; missing or x=0 → 2026.
     */
    isSubscriptionPage2026() {
      if (!this.isFeatureEnabled('subscription_page_2026')) {
        return false;
      }
      return this.experimentVariation !== '1';
    },
    // faqsQuestions() {
    //   return this.faqs.reduce((accumulator, currentValue) => accumulator.concat(currentValue.questions), []);
    // },
    pageOgImage() {
      const languageSuffix = ['en', 'ja', 'ko', 'zh-hant'].includes(this.$i18n.locale) ? this.$i18n.locale : 'en';
      return `https://static.moele.me/img/subscribe/subscription-og-${languageSuffix}.220830.jpg`;
    },
    breadcrumbList() {
      return [
        {
          name: `${this.$t('subscribe.form_2026_plan_title')}: ${this.$t('subscribe.form_2026_plan_subtitle')}`,
          link: this.$link('/subscribe').fullPath(),
          active: true,
        },
      ];
    },
    faqsType() {
      if (this.experimentVariation === '0') {
        return 'subscription_variation_no_ai';
      }
      return this.isSubscriptionPage2026 ? 'subscription' : 'subscription_variation_no_ai';
    },
  },
};
